<template>
	<div v-loading="loading" class="payment-dialog-container">
		<!-- 会员类型切换 -->
		<div class="payment-tabs">
			<div class="tab-item" :class="{ active: activeTab === 'vip' }" @click="activeTab = 'vip'">
				<span class="tab-icon">✦</span>
				VIP会员
			</div>
			<div class="tab-item" :class="{ active: activeTab === 'svip' }" @click="activeTab = 'svip'">
				<span class="tab-icon">✦</span>
				SVIP会员
			</div>
		</div>

		<div class="payment-content">
			<!-- VIP会员内容 -->
			<div v-show="activeTab === 'vip'" class="tab-content vip-content">
				<!-- <h3 class="content-title">VIP会员</h3>
				<div class="content-desc">满足中小企业使用</div> -->

				<!-- 会员价格选择 -->
				<div class="price-options">
					<div
						v-for="(item, index) in vipPriceList"
						:key="index"
						class="price-item"
						:class="{ active: activityPackageInfo.vipId === item.id }"
						@click="handleSelectPrice(item, 'vip')"
					>
						<div v-if="item.tag" class="tag-label">{{ item.tag }}</div>
						<h5 class="price-duration">{{ formatDuration(item.longDuration) }}</h5>
						<div class="price-info">
							<p class="now-price">
								<span>¥</span>
								{{ item.eventPrice }}
							</p>
							<p v-if="item.packagePrice !== item.eventPrice" class="old-price">
								<span>¥</span>
								{{ item.packagePrice }}
							</p>
						</div>
					</div>
				</div>

				<!-- 支付信息 -->
				<div class="payment-info">
					<div class="info-row">
						<span class="info-label">活动到期时间：</span>
						<span class="info-value">{{ activityPackageInfo.vipExpirationTime || '-' }}</span>
					</div>
					<div class="info-row">
						<span class="info-label">会员到期时间：</span>
						<span class="info-value">{{ activityPackageInfo.vipEndingTime || '-' }}</span>
					</div>
					<div class="info-row">
						<span class="info-label">实付金额：</span>
						<p class="actual-price">
							<span>¥</span>
							{{ activityPackageInfo.vipActualPayment || 0 }}
						</p>
					</div>
				</div>

				<div class="payment-notice">
					<h6>购买须知</h6>
					<div class="term-item">
						<el-checkbox v-model="isAgreedTerms" class="term-checkbox"></el-checkbox>
						<p class="text">
							1. 开通前请阅读
							<router-link target="_blank" to="/term" class="term-link">《会员权益说明》</router-link>
							<router-link target="_blank" to="/law" class="term-link">《会员升级说明》</router-link>
						</p>
					</div>
					<div class="term-item">
						<p class="text">2. 完成支付后可在个人中心-我的发票中申请发票</p>
					</div>
				</div>

				<!-- 支付按钮 -->
				<div class="payment-action">
					<el-button
						:loading="loading"
						:disabled="!activityPackageInfo.vipActualPayment"
						class="pay-button vip-button"
						@click="handleCreateOrderInfo('vip')"
					>
						点击购买
					</el-button>
				</div>
			</div>

			<!-- SVIP会员内容 -->
			<div v-show="activeTab === 'svip'" class="tab-content svip-content">
				<!-- <h3 class="content-title">SVIP会员</h3>
				<div class="content-desc">满足大型企业使用</div> -->

				<!-- 会员价格选择 -->
				<div class="price-options">
					<div
						v-for="(item, index) in svipPriceList"
						:key="index"
						class="price-item"
						:class="{ active: activityPackageInfo.svipId === item.id }"
						@click="handleSelectPrice(item, 'svip')"
					>
						<div v-if="item.tag" class="tag-label">{{ item.tag }}</div>
						<h5 class="price-duration">{{ formatDuration(item.longDuration, 'SVIP') }}</h5>
						<div class="price-info">
							<p class="now-price">
								<span>¥</span>
								{{ item.eventPrice }}
							</p>
							<p v-if="item.packagePrice !== item.eventPrice" class="old-price">
								<span>¥</span>
								{{ item.packagePrice }}
							</p>
						</div>
					</div>
				</div>

				<!-- 支付信息 -->
				<div class="payment-info">
					<div class="info-row">
						<span class="info-label">活动到期时间：</span>
						<span class="info-value">{{ activityPackageInfo.svipExpirationTime || '-' }}</span>
					</div>
					<div class="info-row">
						<span class="info-label">会员到期时间：</span>
						<span class="info-value">{{ activityPackageInfo.svipEndingTime || '-' }}</span>
					</div>
					<div class="info-row">
						<span class="info-label">实付金额：</span>
						<p class="actual-price">
							<span>¥</span>
							{{ activityPackageInfo.svipActualPayment || 0 }}
						</p>
					</div>
				</div>

				<div class="payment-notice">
					<h6>购买须知</h6>
					<div class="term-item">
						<el-checkbox v-model="isAgreedTerms" class="term-checkbox"></el-checkbox>
						<p class="text">
							1. 开通前请阅读
							<router-link target="_blank" to="/term" class="term-link">《会员权益说明》</router-link>
							<router-link target="_blank" to="/law" class="term-link">《会员升级说明》</router-link>
						</p>
					</div>
					<div class="term-item">
						<p class="text">2. 完成支付后可在个人中心-我的发票中申请发票</p>
					</div>
				</div>

				<!-- 支付按钮 -->
				<div class="payment-action">
					<el-button
						:loading="loading"
						:disabled="!activityPackageInfo.svipActualPayment"
						class="pay-button svip-button"
						@click="handleCreateOrderInfo('svip')"
					>
						点击购买
					</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { queryMemberPriceByUserId, createOrderInfo } from '@/api/memberBenefit/index'

	// 会员购买弹窗
	export default {
		name: 'PaymentDialog',
		components: {},
		props: {
			oldOrderId: {
				type: String,
				default: ''
			},
			// 当前激活的购买类型，默认vip
			activeVipType: {
				type: String,
				default: 'vip'
			}
		},
		data() {
			return {
				// 当前激活的标签页
				activeTab: '',
				// VIP价格列表
				vipPriceList: [],
				// SVIP价格列表
				svipPriceList: [],
				// 是否同意条款状态
				isAgreedTerms: false,
				// 所选会员活动套餐信息
				activityPackageInfo: {
					// 活动套餐主键id
					id: '',
					// 活动id
					eventId: '',
					// 套餐id
					packageId: '',
					// vip活动套餐主键id
					vipId: '',
					// vip活动id
					vipEventId: '',
					// 套餐id
					vipPackageId: '',
					// VIP活动截止时间
					vipExpirationTime: '',
					// VIP会员预计到期时间
					vipEndingTime: '',
					// VIP实付金额
					vipActualPayment: '',
					// svip活动套餐主键id
					svipId: '',
					// svip活动id
					svipEventId: '',
					// svip套餐id
					svipPackageId: '',
					// SVIP活动截止时间
					svipExpirationTime: '',
					// SVIP会员预计到期时间
					svipEndingTime: '',
					// SVIP实付金额
					svipActualPayment: ''
				},
				// 加载状态
				loading: false
			}
		},
		computed: {
			...mapGetters(['userId'])
		},
		watch: {},
		created() {
			this.activeTab = this.activeVipType
			this.handleGetMemberPriceByUserId()
		},
		mounted() {},
		methods: {
			// 查询会员价格信息
			handleGetMemberPriceByUserId() {
				const params = {
					userId: this.userId
				}
				queryMemberPriceByUserId(params).then(response => {
					const { data } = response
					if (data && data.length) {
						// this.memeberAllPriceList = data
						// 根据会员等级进行过滤，提取VIP和SVIP的价格信息，并根据longDuration字段进行降序排序
						this.vipPriceList = data.filter(item => item.memberGrade === 'VIP').sort((a, b) => b.longDuration - a.longDuration)
						this.svipPriceList = data.filter(item => item.memberGrade === 'SVIP').sort((a, b) => b.longDuration - a.longDuration)

						// 默认选中第一个套餐
						this.handleSelectPrice(this.vipPriceList[0], 'vip')
						this.handleSelectPrice(this.svipPriceList[0], 'svip')
					} else {
						// this.memeberAllPriceList = []
						this.vipPriceList = []
						this.svipPriceList = []
					}
				})
			},

			// 选择价格套餐
			handleSelectPrice(item, type) {
				// this.activityPackageInfo.id = item.id
				this.activityPackageInfo.eventId = item.itemEventPromotionId
				this.activityPackageInfo.packageId = item.itemPackageId
				if (type === 'vip') {
					this.activityPackageInfo.vipId = item.id
					this.activityPackageInfo.vipEventId = item.itemEventPromotionId
					this.activityPackageInfo.vipPackageId = item.itemPackageId
					this.activityPackageInfo.vipExpirationTime = item.eventEndTime
					this.activityPackageInfo.vipEndingTime = this.calculateEndTime(item.longDuration)
					this.activityPackageInfo.vipActualPayment = item.eventPrice
				} else if (type === 'svip') {
					this.activityPackageInfo.svipId = item.id
					this.activityPackageInfo.svipEventId = item.itemEventPromotionId
					this.activityPackageInfo.svipPackageId = item.itemPackageId
					this.activityPackageInfo.svipExpirationTime = item.eventEndTime
					this.activityPackageInfo.svipEndingTime = this.calculateEndTime(item.longDuration)
					this.activityPackageInfo.svipActualPayment = item.eventPrice
				}
			},

			// 计算会员到期时间
			calculateEndTime(days) {
				if (!days) return '-'

				const now = new Date()
				const endDate = new Date(now.getTime() + parseInt(days) * 24 * 60 * 60 * 1000)

				// 格式化日期为 YYYY-MM-DD
				const year = endDate.getFullYear()
				const month = String(endDate.getMonth() + 1).padStart(2, '0')
				const day = String(endDate.getDate()).padStart(2, '0')

				return `${year}-${month}-${day}`
			},

			// 格式化会员时长显示
			formatDuration(days, type = 'VIP') {
				if (!days) return ''

				// 将字符串转为数字
				const daysNum = parseInt(days)

				if (daysNum >= 365) {
					// 计算年数
					const years = Math.floor(daysNum / 365)
					return `${years}年${type}`
				} else {
					// 计算月数 (按30天一个月计算)
					const months = Math.ceil(daysNum / 30)
					return `${months}个月${type}`
				}
			},

			// 生成用户会员活动消费订单信息
			handleCreateOrderInfo(vipType) {
				if (!this.isAgreedTerms) {
					// 未点击阅读购买须知
					this.$modal.msgWarning('请先阅读并勾选购买须知')
					// 获取所有购买须知选择框元素
					const checkboxElements = document.querySelectorAll('.term-checkbox')

					// 为每个选择框添加抖动动画
					checkboxElements.forEach(checkbox => {
						// 先移除可能存在的抖动动画类
						checkbox.classList.remove('shake')

						// 触发重绘
						void checkbox.offsetWidth

						// 添加抖动动画类
						checkbox.classList.add('shake')

						// 动画结束后移除类名
						setTimeout(() => {
							checkbox.classList.remove('shake')
						}, 600) // 动画持续时间
					})
					return
				}

				// 收集活动id和套餐id
				const data = {
					eventId: '',
					packageId: '',
					oldOrderId: this.oldOrderId
				}

				if (vipType === 'vip') {
					data.eventId = this.activityPackageInfo.vipEventId
					data.packageId = this.activityPackageInfo.vipPackageId
				} else if (vipType === 'svip') {
					data.eventId = this.activityPackageInfo.svipEventId
					data.packageId = this.activityPackageInfo.svipPackageId
				}

				this.$modal
					.confirm('请确认是否为您选择的活动套餐创建订单？')
					.then(() => {
						this.loading = true
						return createOrderInfo(data)
					})
					.then(() => {
						this.loading = false
						this.$emit('payOrderSuccess')
						this.$modal.msgSuccess('订单创建成功')
						// 添加redirect跳转，避免重复路由无法跳转报错
						this.$router.push({
							path: '/redirect/user/market/order'
						})
					})
					.catch(() => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.payment-dialog-container {
		width: 840px;
		padding: 0 30px 30px;
		margin: -10px -20px;
		background-image: linear-gradient(0deg, #fff4e9 0%, #ffffff 55%);

		// 切换
		.payment-tabs {
			display: flex;
			justify-content: center;
			border-bottom: 1px solid #eee;
			margin-bottom: 30px;

			.tab-item {
				padding: 10px 20px;
				cursor: pointer;
				position: relative;
				font-size: 16px;
				font-weight: 500;
				color: #666;
				margin-right: 20px;
				transition: all 0.3s;

				.tab-icon {
					color: #ffc664;
					margin-right: 5px;
				}

				&.active {
					color: #333;
					font-weight: bold;

					&::after {
						content: '';
						position: absolute;
						bottom: -1px;
						left: 0;
						width: 100%;
						height: 2px;
						background-image: linear-gradient(90deg, #ffc664 0%, #ff9538 100%);
					}

					&:nth-child(2) {
						&::after {
							background-image: linear-gradient(90deg, #fe8e8a 0%, #f94825 100%);
						}

						.tab-icon {
							color: #fe8e8a;
						}
					}
				}
			}
		}

		.payment-content {
			.tab-content {
				.content-title {
					font-size: 22px;
					font-weight: bold;
					margin-bottom: 5px;
				}

				.content-desc {
					font-size: 14px;
					color: #666;
					margin-bottom: 20px;
				}

				.price-options {
					display: flex;
					justify-content: space-between;
					margin-bottom: 20px;

					.price-item {
						width: 30%;
						background-color: #ffffff;
						border-radius: 8px;
						border: solid 1px #ffc99d;
						cursor: pointer;
						transition: all 0.3s ease;
						position: relative;
						overflow: visible;
						display: flex;
						flex-direction: column;

						.tag-label {
							position: absolute;
							top: -10px;
							left: -10px;
							background-image: linear-gradient(135deg, #ff7a18 0%, #ff9538 100%);
							color: #fff;
							font-size: 12px;
							padding: 2px 10px;
							z-index: 2;
							font-weight: bold;
							box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
							clip-path: polygon(0 0, 100% 0, 100% 70%, 85% 100%, 0 100%);
							transform: rotate(-5deg);
						}

						.price-duration {
							padding: 10px 0;
							font-size: 24px;
							color: #934e25;
							text-align: center;
							border-radius: 8px 8px 0 0;
						}

						.price-info {
							flex: 1;
							display: flex;
							flex-direction: column;
							justify-content: center;
							padding: 25px 0;
							text-align: center;

							.now-price {
								font-size: 36px;
								font-weight: bold;
								color: #e64000;
								margin-bottom: 5px;

								span {
									font-size: 16px;
								}
							}

							.old-price {
								font-size: 24px;
								color: #a4a4a4;
								text-decoration: line-through;

								span {
									font-size: 20px;
								}
							}
						}

						&.active {
							animation: pulse 0.5s ease;

							&::before {
								content: '';
								position: absolute;
								right: 0;
								bottom: 0;
								width: 40px;
								height: 40px;
								background: linear-gradient(90deg, #ffc664 0%, #ff9338 100%);
								clip-path: polygon(100% 0, 100% 100%, 0 100%);
								border-radius: 0 0 8px 0;
							}

							&::after {
								content: '';
								position: absolute;
								right: 5px;
								bottom: 5px;
								width: 16px;
								height: 12px;
								background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E%3Cpath d='M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z' fill='%23ffffff'/%3E%3C/svg%3E");
								background-repeat: no-repeat;
								background-size: 100%;
								background-position: 50% 50%;
								z-index: 1;
							}
						}
					}
				}

				// 价格
				.payment-info {
					padding: 15px 0;
					border-radius: 8px;
					// margin-bottom: 20px;

					.info-row {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-bottom: 10px;

						.info-label {
							font-size: 18px;
							color: #333333;
						}

						.info-value {
							font-size: 18px;
							color: #333333;
						}

						.actual-price {
							font-size: 24px;
							font-weight: bold;
							color: #e64000;
							margin: 0;

							span {
								font-size: 16px;
							}
						}
					}
				}

				.payment-notice {
					h6 {
						font-size: 18px;
						color: #934e25;
						margin-bottom: 16px;
					}
					.term-item {
						display: flex;
						align-items: center;
						margin-bottom: 10px;

						.term-checkbox {
							margin-right: 10px;

							::v-deep .el-checkbox__inner {
								width: 18px;
								height: 18px;
								border-color: #ff9538;

								&:after {
									border-color: #fff;
								}
							}

							::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
								background-color: #ff9538;
								border-color: #ff9538;

								&::after {
									height: 9px;
									left: 6px;
								}
							}
						}

						.term-link {
							color: #236fca;
							text-decoration: none;
							margin: 0 3px;

							&:hover {
								text-decoration: underline;
							}
						}

						.text {
							font-size: 16px;
							color: #b26a3f;
							line-height: 28px;
						}

						&:last-child {
							.text {
								padding-left: 28px; // 与复选框对齐
							}
						}
					}
				}

				// 支付按钮
				.payment-action {
					margin-top: 20px;
					text-align: center;

					.pay-button {
						width: 180px;
						height: 40px;
						border: none;
						border-radius: 4px;
						font-size: 16px;
						color: #ffffff;
						transition: all 0.3s ease;

						&.vip-button {
							background-image: linear-gradient(90deg, #ffc664 0%, #ff9538 100%);

							&:hover:not(:disabled) {
								background-image: linear-gradient(90deg, #ffd17a 0%, #ffa04d 100%);
								transform: translateY(-2px);
								box-shadow: 0 4px 12px rgba(255, 149, 56, 0.3);
							}
						}

						&.svip-button {
							background-image: linear-gradient(90deg, #fe8e8a 0%, #f94825 100%);

							&:hover:not(:disabled) {
								background-image: linear-gradient(90deg, #ff9e9a 0%, #fa5a3a 100%);
								transform: translateY(-2px);
								box-shadow: 0 4px 12px rgba(249, 72, 37, 0.3);
							}
						}

						&:disabled {
							opacity: 0.6;
							cursor: not-allowed;
						}
					}
				}
			}

			// vip
			.vip-content {
				.price-options {
					.price-item {
						.tag-label {
							background-image: linear-gradient(135deg, #ff7a18 0%, #ff9538 100%);
						}

						.price-duration {
							background: linear-gradient(90deg, rgba(255, 216, 142, 0.4) 0%, rgba(250, 162, 80, 0.4) 100%);
						}

						&.active {
							border: solid 1px #fda155;
							box-shadow: 0 2px 10px rgba(255, 149, 56, 0.2);

							.price-duration {
								background-image: linear-gradient(90deg, #ffc664 0%, #ff9338 100%);
								color: #fff;
							}
						}
					}
				}
			}

			// svip
			.svip-content {
				.price-options {
					.price-item {
						border: solid 1px #ffbcb2;

						.tag-label {
							background-image: linear-gradient(135deg, #fe8e8a 0%, #f84621 100%);
						}

						.price-duration {
							background-image: linear-gradient(90deg, #ffe5dd 0%, #ffd3c9 100%);
							color: #f2450a;
						}

						&.active {
							border: solid 1px #ff9282;
							box-shadow: 0 2px 10px rgba(249, 72, 37, 0.2);

							.price-duration {
								background-image: linear-gradient(90deg, #fe8e8a 3%, #f84621 100%);
								color: #fff;
							}

							&::before {
								background: linear-gradient(135deg, #fe8e8a 3%, #f84621 100%);
							}
						}
					}
				}
			}
		}
	}

	@keyframes pulse {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.03);
		}
		100% {
			transform: scale(1);
		}
	}
</style>
